import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import ScaleFadeTransition from "shared/components/ScaleFadeTransition";
import ProfileComment from "shared/components/ProfileComment";

import "apps/messenger/components/MainWindow/Attachments.scss";

const Attachments = ({
	comment,
	onCommentChange,
}) => {
	const handleRemoveComment = () => onCommentChange(null);

	return (
		<div className={classnames("messenger-attachments", {
			"messenger-attachments--has-attachments": !!comment,
		})}>
			<ScaleFadeTransition>
				{comment && (
					<ProfileComment {...comment} onRemove={handleRemoveComment} />
				)}
			</ScaleFadeTransition>
		</div>
	);
};

Attachments.propTypes = {
	comment: PropTypes.object,
	onCommentChange: PropTypes.func.isRequired,
};

Attachments.defaultProps = {
	comment: null,
};

export default Attachments;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Attachments.jsx